import React from 'react';
import Box, { BoxProps } from '@mui/material/Box';
import { amber } from '@mui/material/colors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faInfoCircle as circleLight,
  faExclamationCircle as exclamationCircleLight,
  faQuestionCircle as questionLight,
  faCheckCircle as successLight,
} from '@fortawesome/pro-light-svg-icons';
import {
  faInfoCircle as circleRegular,
  faExclamationCircle as exclamationCircleRegular,
  faQuestionCircle as questionRegular,
  faCheckCircle as successRegular,
} from '@fortawesome/pro-regular-svg-icons';

import { ColorPalette } from '../config/color-palette';

export type SeverityIconLevelType = 'info' | 'question' | 'success' | 'alert' | 'warning';
type SeverityIconVariantType = 'light' | 'regular';

interface ISeverityIconProps {
  level?: SeverityIconLevelType;
  variant?: SeverityIconVariantType;
  sx?: BoxProps['sx'];
}

function getIcon(props: ISeverityIconProps) {
  const { level, variant = 'light' } = props;
  switch (level) {
    case 'info':
      return variant === 'light' ? circleLight : circleRegular;
    case 'question':
      return variant === 'light' ? questionLight : questionRegular;
    case 'success':
      return variant === 'light' ? successLight : successRegular;
    case 'warning':
      return variant === 'light' ? exclamationCircleLight : exclamationCircleRegular;
    default:
      return variant === 'light' ? circleLight : circleRegular;
  }
}

function getColor(props: ISeverityIconProps) {
  const { level } = props;
  switch (level) {
    case 'info':
      return ColorPalette.HyperLink;
    case 'question':
      return amber[700];
    case 'success':
      return ColorPalette.GrannySmithGreen;
    case 'warning':
      return ColorPalette.HotAurora;
    default:
      return ColorPalette.HyperLink;
  }
}

export function SeverityIcon(props: ISeverityIconProps) {
  const { level, variant = 'light', sx } = props;

  const icon = getIcon({ level, variant });
  const styles = {
    color: getColor({ level }),
    ...sx,
  };

  return (
    <Box sx={styles}>
      <FontAwesomeIcon icon={icon} />
    </Box>
  );
}
